"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportTicketResolution = exports.SupportRoomRecoveryDecision = exports.SupportRoomErrorCode = void 0;
var SupportRoomErrorCode;
(function (SupportRoomErrorCode) {
    SupportRoomErrorCode["ROOM_UNAVAILABLE"] = "ROOM_UNAVAILABLE";
    SupportRoomErrorCode["SUPPORT_ROOM_REQUEST_FAILED"] = "SUPPORT_ROOM_REQUEST_FAILED";
})(SupportRoomErrorCode || (exports.SupportRoomErrorCode = SupportRoomErrorCode = {}));
var SupportRoomRecoveryDecision;
(function (SupportRoomRecoveryDecision) {
    SupportRoomRecoveryDecision["end"] = "end";
    SupportRoomRecoveryDecision["displaced"] = "displaced";
    SupportRoomRecoveryDecision["rejoin"] = "rejoin";
})(SupportRoomRecoveryDecision || (exports.SupportRoomRecoveryDecision = SupportRoomRecoveryDecision = {}));
var SupportTicketResolution;
(function (SupportTicketResolution) {
    SupportTicketResolution["RESOLVED"] = "resolved";
    SupportTicketResolution["UNRESOLVED"] = "unresolved";
})(SupportTicketResolution || (exports.SupportTicketResolution = SupportTicketResolution = {}));
